import { PORTAL_RESUME_PARAMS } from "@shared-ui/utils/returnTo";

/**
 * ログイン後にプロダクトへ戻す URL。ワンタイムコードなどは URL フラグメントに載せる
 * （サーバへ送られず、プロダクトの loader が読んで履歴から消す）。
 *
 * PRODUCT_DEV-1129: `returnTo` はセッション切れの前に見ていた画面。プロダクトが検査してから移る。
 */
export const buildProductRedirectUrl = (
  url: string,
  args: { authCode: string; auto: boolean; returnTo?: string | null },
): string => {
  const params = new URLSearchParams();
  params.set("authCode", args.authCode);
  if (args.auto) {
    params.set("auto", "1");
  }
  if (args.returnTo) {
    params.set(PORTAL_RESUME_PARAMS.returnTo, args.returnTo);
  }
  return `${url}#${params.toString()}`;
};
